import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-marker-base-icon',
    templateUrl: './map-marker-base-icon.component.svg',
    styleUrls: ['./map-marker-base-icon.component.scss'],
    standalone: false,
})
export class MapMarkerBaseIconComponent {}
